import React from 'react';
import { theme, style, GROUP_ROLES } from 'constants';
import { IcoAdmin } from 'icons';
import { Text, View, isWeb } from 'core';
import { lang } from 'lang';

const styles = style({
  holder: {
    paddingHorizontal: 4,
    alignItems: 'center',
    justifyContent: 'center'
  }
});

export const Badge = ({ style, title, title_style, color, size, ...props }) => {
  const Color = color || theme.error_color;
  const Size = size || 22;
  if (!title) {
    return null;
  }
  return (
    <View
      style={[
        styles.holder,
        {
          backgroundColor: Color,
          borderRadius: Size / 2,
          minWidth: Size,
          height: Size
        },
        style
      ]}
    >
      <Text style={[{ color: 'white', fontSize: Size / 2, lineHeight: isWeb ? Size : null }, title_style]}>{title}</Text>
    </View>
  );
};

export const AdminBadge = ({ style, is_admin }) => (is_admin ? <IcoAdmin style={[{ marginLeft: 5 }, style]} color={theme.success_color} size={14} /> : null);



// WEBPACK FOOTER //
// ./src/components/core/badge.js